import React from 'react';

const Spinner = ({ label }) => (
	<div className="flex w-full flex-col items-center gap-[12px] py-[24px]">
		<div className="h-[32px] w-[32px] animate-spin rounded-full border-[3px] border-[#d5d7da] border-t-[#676AF6]" />
		{label ? <p className="text-[13px] text-[#7d7d7d]">{label}</p> : null}
	</div>
);

export default Spinner;
